import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import bannerImage from "../../Images/Banner/Gov-body.webp";

const TermsCondition = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const termsData = [
        {
            title: "Introduction",
            icon: "ti ti-file-description",
            description:
                "Welcome to the official website of the ISBM University. By accessing or utilizing this website, you agree to comply with and be bound by the following terms and conditions, which govern your relationship with ISBM University concerning this website. Please review these terms carefully before using the website.",
        },
        {
            title: "Acceptance of Terms",
            icon: "ti ti-shield-check",
            description:
                "By continuing to access or use this website, you acknowledge that you have read, understood, and agree to be bound by these terms and conditions, as well as any applicable laws and regulations. If you do not agree with any of these terms, you are advised to refrain from using the website.",
        },
        {
            title: "Modifications of Terms",
            icon: "ti ti-edit",
            description: "ISBM University reserves the right to amend or revise these terms and conditions at its sole discretion and at any time. Any modifications will become effective immediately upon being posted on the website. It is your responsibility to review these terms periodically. Continued use of the website following the posting of changes signifies your acceptance of those changes."
        },
        {
            title: "Eligibility & Use",
            icon: "ti ti-lock",
            description:
                "Access to certain areas of the website or to specific services provided by ISBM University may be restricted to users who meet the eligibility criteria, including age requirements and compliance with local regulations. By using this website, you confirm that you meet such eligibility criteria and that you have the legal capacity to agree to these terms.",
        },
        {
            title: "Admissions & Enrollment",
            icon: "ti ti-school",
            description:
                "Admission to ISBM University and participation in its academic programs are subject to the institution's admissions policies, which are periodically reviewed and updated. These policies outline the qualifications, application process, and criteria for acceptance. Enrollment in any program or course offered by ISBM University does not guarantee completion or certification unless all academic and administrative requirements are fulfilled.",
        },
        {
            title: "Use of Website",
            icon: "ti ti-lock",
            description: "This website is provided for educational and informational purposes only. You agree to use the website in a manner that is lawful and in compliance with these terms. Misuse of the website, including but not limited to the dissemination of harmful content, unauthorized access, or interference with the site’s operation, is strictly prohibited."
        },
        {
            title: "Intellectual Property Rights",
            icon: "ti ti-copyright",
            description:
                "All intellectual property rights, including but not limited to copyrights, trademarks, service marks, logos, and design elements displayed on the website, are owned by or licensed to ISBM University. The content on this website is protected under applicable intellectual property laws. Any unauthorized use, reproduction, or distribution of materials from this website is strictly prohibited and may result in legal action.",
        },
        {
            title: "User-Generated Content",
            icon: "ti ti-users",
            description:
                "If the website allows you to submit or post content, such as comments or media, you retain ownership of the intellectual property rights in that content. However, by submitting such content, you grant ISBM University a worldwide, non-exclusive, royalty-free license to use, distribute,reproduce, modify, adapt, and publicly display that content. You are solely responsible for any content you submit, and you agree not to post any material that is unlawful, offensive, or infringes on third-party rights.",
        },
        {
            title: "External Links",
            icon: "ti ti-link",
            description:
                "This website may include links to external websites or third-party resources for the convenience of users. ISBM University does not endorse or assume any responsibility for the content, products, or services available on third-party websites. You acknowledge that any interaction with third-party websites is solely at your own risk, and ISBM University is not liable for any damages or losses incurred.",
        },
        {
            title: "Disclaimer of Warranties",
            icon: "ti ti-alert-circle",
            description:
                "ISBM University strives to ensure the accuracy and reliability of the information presented on this website. However, the website and all content are provided as is and as available, without any express or implied warranties. ISBM University does not warrant that the website will be uninterrupted, error-free, or free from viruses or other harmful components. Use of the website is at your own risk.",
        },
        {
            title: "Limitation of Liability",
            icon: "ti ti-alert-triangle",
            description:
                "To the fullest extent permitted by law, ISBM University disclaims all liability for any direct, indirect, incidental, consequential, or punitive damages arising from or related to your use of the website, including but not limited to errors, omissions, interruptions, defects, or delays in operation. Your sole remedy for dissatisfaction with the website is to discontinue its use.",
        },
        {
            title: "Privacy and Data Protection",
            icon: "ti ti-database",
            description:
                "ISBM University is committed to safeguarding your privacy. Any personal information collected through this website will be processed in accordance with our [Privacy Policy](link to privacy policy). By using this website, you consent to the collection, use, and sharing of your data as outlined in the policy.",
        },
        {
            title: "Governing Law and Jurisdiction",
            icon: "ti ti-gavel",
            description:
                "These terms and conditions are governed by and construed in accordance with the laws of Maharashtra Jurisdiction. Any disputes arising out of or relating to these terms, or the use of the website, shall be subject to the exclusive jurisdiction of the courts located in [Mumbai/Maharashtra/India].",
        },
        {
            title: "Termination of Access",
            icon: "ti ti-ban",
            description:
                "ISBM University reserves the right to terminate or suspend your access to the website or any part thereof at any time, without notice, for any reason, including but not limited to your violation of these terms and conditions or any applicable law.",
        },
        {
            title: "Contact Information",
            icon: "ti ti-mail",
            description: (
                <>
                    For any concerns, reach us at: <br />
                    <b>Email:</b> support@isbm.org.in <br />
                    <b>Phone:</b> +91 89281 11111
                </>
            ),
        },
    ];

    return (
        <>
            <title>ISBM University | Terms And Conditions | Servies</title>
            <meta
                name="description"
                content="ISBM University’s terms & conditions for our services. Get detailed insights on policies, guidelines, user the provider of a service and its user."
            />
            <Topnav />

            {/* Hero Banner */}
            <section
                className="section-hero-banner ptb-50"
                style={{
                    backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${bannerImage})`,
                }}
            >
                <div className="banner-hero-overlay">
                    <div className="container-xxl">
                        <div className="section-hero-content text-center">
                            <h1>Terms and Conditions</h1>
                            <ol className="breadcrumb mt-3 text-center mb-0 justify-content-center">
                                <li className="breadcrumb-item">
                                    <a
                                        href="/"
                                        style={{ color: "#fff", textDecoration: "none" }}
                                    >
                                        Home
                                    </a>
                                </li>
                                <li
                                    className="breadcrumb-item active text-white"
                                    aria-current="page"
                                >
                                    Terms and Conditions
                                </li>
                                <hr className="section-divider" />
                            </ol>
                        </div>
                    </div>
                </div>
            </section>

            <section className="ptb-50 bg-white">
                <div className="container-xxl">
                    <div className=" mb-5">
                        <h2 className="section-title-start modern-title text-blue mt-3">
                            Terms and Conditions
                        </h2>
                        <p className="section mx-auto">
                            Please read these terms carefully before using our website
                        </p>
                    </div>

                    {/* Dynamic Cards */}
                    <div className="row g-4">
                        {termsData.map((item, index) => (
                            <div className="col-lg-6 col-12" key={index}>
                                <div className="innovation-card shadow h-100">
                                    <div className="row align-items-center mb-3">
                                        {/* Icon */}
                                        <div className="innovation-icon col-3 ms-5">
                                            <i className={item.icon}></i>
                                        </div>

                                        {/* Title */}
                                        <div className="col-9">
                                            <h3 className="fw-bold text-center mb-0">{item.title}</h3>
                                        </div>
                                    </div>

                                    <p className="mb-4">{item.description}</p>

                                    {item.features && (
                                        <ul className="innovation-features">
                                            {item.features.map((feature, idx) => (
                                                <li key={idx}>
                                                    <i className="ti ti-check text-purple"></i> {feature}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <Footer />
        </>
    );
};

export default TermsCondition;
